export const ERROR_TEXTS = {
  required: 'Обязательное поле',
  email: 'Неверный формат e-mail',
  phone: 'Неверный формат телефона',
  min: (num: number) => `Минимальное значение - ${num}`,
  max: (num: number) => `Максимальное значение - ${num}`,
  minLength: (num: number) => `Минимальная длина - ${num}`,
  maxLength: (num: number) => `Максимальное длина - ${num}`,
};
